module.exports = __webpack_public_path__ + "media/images/universe_landing_pages/hero_banner/component/beauty-mobile@2x-69265f4300a0cccc7b7f11613af17eab.jpg";